/** @format */

export enum TextSize {
  title = "40px",
  medium = "24px",
  normal = "16px",
  label = "12px",
  inputValue = "22px",
}
